<script lang="ts">
    import {enhance} from "$app/forms";
    import type {Employee} from "$lib/types/employee";
    import type {Writable} from "svelte/store";
    import {getContext} from "svelte";
    import {Avatar, Modal} from "flowbite-svelte";
    import ImageCropper from "$lib/components/ImageCropper.svelte";

    export let employee: Employee;
    if (!employee) {
        (getContext('employee') as Writable<Employee>).subscribe(
            value => {
                employee = value;
            }
        );
    }

    export let editable = false;
    export let loading = false;


    export let bgColor = "bg-neutral-500"

    let sizes = {
        sm: "h-7 w-7",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14",
        "2xl": "h-16 w-16",
        "3xl": "h-32 w-32"
    }
    export let size: keyof typeof sizes = "md";
    let open = false;
</script>
<style>
    .avatar-file{
        background-size: cover;
        background-position: center center;
    }
</style>

{#if employee}
    <button class="relative select-none block {editable ? 'cursor-pointer' : ''}" on:keyup={(e) => e.key === 'Enter' && open}
            on:click={() => editable ?  open = !open : null}>
        {#if employee.avatarFile}
<!--            <Avatar src={employee.avatarFile} class="{sizes[size]}" />-->
            <span class="inline-flex {sizes[size]} avatar-file items-center justify-center rounded-full ring-1 ring-primary-300" style="background-image: url('{employee.avatarFile}')">

            </span>
        {:else if employee.firstName && employee.lastName}
            <span class="inline-flex {sizes[size]} {bgColor} items-center justify-center rounded-full ring-1 ring-primary-300">
              <span class="font-medium text-{size} leading-none text-white">{employee?.firstName[0] + employee?.lastName[0]}</span>
            </span>
        {/if}
    </button>
{/if}

<Modal bind:open={open} title="Employee Profile" size="xl" tag="div">
    <form
            method="post"
            enctype="multipart/form-data"
            action="?/upload_avatar"
            class="flex flex-col gap-3"
            use:enhance={() => {loading=true;return ({ update }) => {loading=false; update()}}}>
        <ImageCropper/>
    </form>
</Modal>